import Vue from 'vue'
import axios from 'axios'
import config from '@/config'

const catalog = {
  namespaced: true,
  state: {
    search: {},
    validatorResult: {}
  },
  actions: {
    init ({ commit }) {
      try {
        commit('SET_SEARCH', {})
        commit('SET_SEARCH_UPLOAD', {})
      } catch (error) {
        throw new Error(error)
      }
    },

    async uploadSearch ({ commit }, formData) {
      axios.post(`${config.ENDPOINTS.CAT4MRO_APIHTTP}/api/search/upload`, formData,
        { headers: {'Content-Type': 'multipart/form-data'} }
      ).then(function (response) {
        commit('SET_SEARCH_UPLOAD', response.data)
      }).catch(function (e) {
        console.error('UPLOAD FAILURE!!')
        console.error(e)
      })
    }
  },
  mutations: {
    SET_SEARCH (state, data) {
      Vue.set(state, 'search', data)
    },
    SET_SEARCH_UPLOAD (state, data) {
      Vue.set(state, 'validatorResult', data)
    }
  },
  getters: {
    validatorResultInfo: state => state.validatorResult,
    searchInfo: state => state.search
  }
}

export default catalog



// WEBPACK FOOTER //
// ./src/store/modules/search.js